// material
import { Stack } from "@mui/material";

// ----------------------------------------------------------------------

export default function Vibe() {
  return (
    <Stack sx={{ py: "3%" }}>
      <Stack direction="row" spacing={1}>
        <Stack spacing={1} sx={{ width: "23%" }}>
          <img src="/assets/IB-3.jpg" style={{ width: "100%" }} />
          <img src="/assets/IB-5.jpg" style={{ width: "100%" }} />
          <img src="/assets/IB-35 1.png" style={{ width: "100%" }} />
          <img src="/assets/image3.png" style={{ width: "100%" }} />
        </Stack>
        <Stack spacing={1} sx={{ width: "77%" }}>
          <Stack direction="row" spacing={1}>
            <Stack sx={{ width: "52%" }}>
              <img
                src="/assets/IB-4.jpg"
                style={{ width: "100%", height: "100%" }}
              />
            </Stack>
            <Stack sx={{ width: "24%" }}>
              <img src="/assets/IB-8.jpg" style={{ width: "100%" }} />
            </Stack>
            <Stack sx={{ width: "24%" }}>
              <img src="/assets/IB-9.jpg" style={{ width: "100%" }} />
            </Stack>
          </Stack>
          <Stack direction="row" spacing={1}>
            <Stack sx={{ width: "47%" }}>
              <img
                src="/assets/IB-6.jpg"
                style={{ width: "100%", height: "100%" }}
              />
            </Stack>

            <Stack sx={{ width: "53%" }}>
              <img src="/assets/IB-1-1.png" style={{ width: "100%" }} />
            </Stack>
          </Stack>
          <Stack direction="row" spacing={1}>
            <Stack spacing={1} style={{ width: "50%" }}>
              <img src="/assets/IB-10.jpg" style={{ width: "100%" }} />
              <img src="/assets/IB-15 1.png" style={{ width: "100%" }} />
              <img
                src="/assets/image2.png"
                style={{ width: "100%", height: "100%" }}
              />
            </Stack>
            <Stack spacing={1} style={{ width: "50%" }}>
              <img src="/assets/IB-39 2.png" style={{ width: "100%" }} />
              <img src="/assets/IB-38 1.png" style={{ width: "100%" }} />
              <img src="/assets/image1.png" style={{ width: "100%" }} />
            </Stack>
          </Stack>
        </Stack>
      </Stack>
    </Stack>
  );
}
